<div class="copo-container settings-general" *ngIf="fetched else loading">
	<div class="add-notification-container">
		<button (click)="openAddSubscriptionDialog();getRouteParam()" *ngIf="enableUsertoUpdate" type="button" mat-button color="accent"
			class="notification-button"
			><span class="text-color" translate>user.notifications.btn.add.subscription</span>
			<mat-icon iconPositionEnd svgIcon="md:add" class="icon-color"></mat-icon>
		</button>
		<mat-form-field class="organization-list-form">
			<mat-label translate>datacenter-filter.organization-name</mat-label>
			<mat-select (selectionChange)="handleOrganizationNotificationsUpdated($event.value)"  [value]="selectedOrganizationId">
				<mat-option value="ALL">
					<span translate>filter.all</span>
				</mat-option>
				<mat-option *ngFor="let org of organizationsList" [value]="org.organizationId">
					{{ org.organizationName }}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
	<div>
		<div class="card-block" *ngFor="let group of filteredGroups">
			<div class="card-title">
				<div class="card-title-label" translate>user.card.notifications.title</div>
				<div class="card-title-comment" translate>user.card.notifications.title.desc</div>
				<div class="card-title-right-comment">{{group.organizationName.toUpperCase()}}</div>
			</div>
			<div>
				<div class="card-block-toggle-block">
					{{group.supplierName}}
				</div>
				<div class="copo-card-grid-container">
					<ag-grid-angular
						class="ag-theme-balham"
						[gridOptions]="gridOptions"
						[modules]="modules"
						[rowData]="group.notifications">
					</ag-grid-angular>
				</div>

			</div>
		</div>
		<div class="copo-card-grid-container" *ngIf="userNotifications?.length === 0 ">
			<span translate>user.card.notifications.no-data</span>
		</div>
	</div>
</div>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>
